/**
 * Created by BFR on 04/05/2017.
 */
define('lisSmpMatDetailTabController',[
  'module',
  'underscore',
  'backbone',
  'app',
  'lisSmpMatDetailView',
  'settings'
], function(
  module,
  _,
  Backbone,
  App,
  View
) {
  'use strict';

  var LisSmpMatDetailTabController = {
    showTab: function(data) {
      if (!data.tab) {
        data.tab = 'detail';
      }
      this.showLisSmpMatInfo(data);
    },

    showLisSmpMatInfo: function(data) {
      var that = this;
      this.model = data.model;
      this.tab = data.tab;
      this.data = data;
      that.createView();
    },

    createView: function() {
      var view;
      view = new View({
        model: this.model
      });
      view.tempModel = new Backbone.Model(this.model.toJSON());
      this.view = view;

      App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('lisSmpMatDetailTab').show(view);
    }
  };

  module.exports = LisSmpMatDetailTabController;
});
